let cachedToken = null;
let tokenExpiry = null;

/**
 * Fetches 1688 API token using the configured API key.
 * Caches the token for its validity period (default 300s).
 * @returns {Promise<string>} The API token
 */
export const fetchToken = async () => {
    const now = Math.floor(Date.now() / 1000);

    // Return cached token if still valid (with 10s buffer)
    if (cachedToken && tokenExpiry && now < tokenExpiry - 10) {
        return cachedToken;
    }

    const apiUrl = process.env.REACT_APP_APIUrl1688;
    const apiKey = process.env.REACT_APP_GLOBAL_X_API_KEY;

    if (!apiUrl || !apiKey) {
        if (!apiUrl) console.error('- REACT_APP_APIUrl1688 is missing or undefined');
        if (!apiKey) console.error('- REACT_APP_GLOBAL_X_API_KEY is missing or undefined');
        throw new Error("API URL or Key is not configured. Check env-template.txt for required variables.");
    }

    try {
        const response = await fetch(`${apiUrl}/generate-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ apiKey }),
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch token!!`);
        }

        const data = await response.json();

        if (data && data.token) {
            cachedToken = data.token;
            // Use expiresInSeconds from response or default to 300
            const expiresIn = data.expiresInSeconds || 300;
            tokenExpiry = now + expiresIn;
            return cachedToken;
        } else {
            throw new Error("Invalid token response format");
        }
    } catch (error) {
        console.error("Error generating token:", error);
        throw error;
    }
};
